import { useState } from "react";

/**
 * Custom hook for table sorting functionality
 * @param {Object} initialParams - Initial pagination parameters
 * @param {Function} onParamsChange - Callback when pagination params change
 * @returns {Object} - Sorting handlers and state
 */
export const useTableSorting = (initialParams, onParamsChange) => {
  const [paginationParams, setPaginationParams] = useState(initialParams);

  const handleRequestSort = (property) => {
    // Do not sort on certain columns
    if (
      property === "checkbox-all" ||
      property === "checkbox-header" ||
      property === "actions-header"
    ) {
      return;
    }

    const isAsc =
      paginationParams.order_by === property &&
      paginationParams.order === "asc";

    const newParams = {
      ...paginationParams,
      order_by: property,
      order: isAsc ? "desc" : "asc",
      page: 0, // Reset to first page when sorting changes
    };

    setPaginationParams(newParams);

    // Call the callback if provided
    if (onParamsChange) {
      onParamsChange(newParams);
    }
  };

  const onChangeRowsPerPage = (value) => {
    const newParams = {
      ...paginationParams,
      page_size: value,
      page: 0, // Reset to first page when page size changes
    };

    setPaginationParams(newParams);

    // Call the callback if provided
    if (onParamsChange) {
      onParamsChange(newParams);
    }
  };

  const onChangePage = (newPage) => {
    const newParams = {
      ...paginationParams,
      page: newPage,
    };

    setPaginationParams(newParams);

    // Call the callback if provided
    if (onParamsChange) {
      onParamsChange(newParams);
    }
  };

  return {
    paginationParams,
    setPaginationParams,
    handleRequestSort,
    onChangeRowsPerPage,
    onChangePage,
  };
};

export default useTableSorting;
